import { useState } from "react";

import styles from "./BookWithConfidence.module.css";
import EnquiryModal from "./EnquiryModal";

function BookWithConfidence() {
  const [showModal, setShowModal] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className={styles.content}>
        <p>
          Your Golf Travel provides golf breaks, holidays & tournament
          experiences at over 3500 destinations in the UK, Ireland, Europe &
          worldwide
        </p>
        <button
          className={styles.cta}
          data-gtm-category="All pages"
          data-gtm-action="General enquiry"
          data-gtm-label="Clicked"
          onClick={openModal}
        >
          Enquire now
        </button>
      </div>
      <EnquiryModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default BookWithConfidence;
export { BookWithConfidence };
